import React from "react";
import { Notification } from '@progress/kendo-react-notification';
import { Fade } from '@progress/kendo-react-animation';

export const Alert = ({ message, type, onClose }) => {
    return (
        <Fade>
            <Notification
                type={{
                    style: type,
                    icon: true
                }}
                closable={true}
                onClose={onClose}
            >
                <span>{message}</span>
            </Notification>
        </Fade>
    );
};